<!--
 * @Author: 曹捷
 * @Date: 2021-04-06 11:54:40
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-10-21 16:35:02
 * @Description: 菜单侧边栏
-->
<template>
  <a-layout-sider class="menuMain" collapsible v-model:collapsed="config.menu.opened" :width="config.menu.width" :collapsedWidth="config.menu.collapsedWidth"
    :trigger="!config.menu.trigger?null:undefined">
    <slot></slot>
    <!-- 自定义触发菜单显示隐藏按钮 -->
    <template v-slot:trigger v-if="config.menu.trigger">
      <i class="iconfont " :class="config.menu.opened?'icon-arrow-double-right':'icon-arrow-double-left'"></i>
    </template>
  </a-layout-sider>
</template>

<script>
import { useStore } from 'vuex'
import { computed } from 'vue'
// import {Layout} from 'ant-design-vue'
export default {
  // components:{ALayout:Layout ,ALayoutSider:Layout.Sider},
  setup () {
    let store = useStore()
    let _computed = {
      config: computed(() => store.state.settings)
    }
    return {
      ..._computed
    }
  }
}
</script>

<style lang="less">
.menuMain {
  .ant-layout-sider-trigger {
    border-right: 1px solid var(--border);
    border-top: 1px solid var(--border);
    background: transparent !important;
    color: @primary-color;
  }
}
</style>